import { render, staticRenderFns } from "./PerformanceConceptsCreate.vue?vue&type=template&id=4afbc60e&"
import script from "./PerformanceConceptsCreate.vue?vue&type=script&lang=js&"
export * from "./PerformanceConceptsCreate.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceConceptsCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports